import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.season');
import { OnInit, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-season',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.season/view.scss */
:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #FFFFFF;
}

.layout-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.layout-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  /* Native scrollbar styling */
  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #A1A1AA transparent;
}
.layout-content::-webkit-scrollbar {
  width: 6px;
}
.layout-content::-webkit-scrollbar-track {
  background: transparent;
}
.layout-content::-webkit-scrollbar-thumb {
  background: #A1A1AA;
  border-radius: 3px;
}
.layout-content::-webkit-scrollbar-thumb:hover {
  background: #71717A;
}`],
})
export class LayoutSeasonComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('scrollContainer') scrollContainer: ElementRef;

    public isScrolled: boolean = false;
    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();

        this.routerSub = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.resetScrollPosition();
                this.applyPageTransition();
            }
        });
    }

    public ngAfterViewInit() {
        this.resetScrollPosition();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public onContentScroll(event: Event) {
        const el = event.target as HTMLElement;
        const scrolled = el.scrollTop > 20;
        if (scrolled !== this.isScrolled) {
            this.isScrolled = scrolled;
            this.service.render();
        }
    }

    public scrollToTop() {
        if (this.scrollContainer?.nativeElement) {
            this.scrollContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    private resetScrollPosition() {
        const container = this.scrollContainer?.nativeElement as HTMLElement;
        if (container) {
            const previousScrollBehavior = container.style.scrollBehavior;
            container.style.scrollBehavior = 'auto';
            container.scrollTop = 0;
            container.scrollLeft = 0;
            container.style.scrollBehavior = previousScrollBehavior;
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

        if (this.isScrolled) {
            this.isScrolled = false;
            this.service.render();
        }
    }

    private applyPageTransition() {
        const container = this.scrollContainer?.nativeElement;
        if (!container) return;
        const pageEl = container.querySelector('router-outlet + *');
        if (pageEl) {
            pageEl.classList.remove('page-enter');
            void pageEl.offsetWidth;
            pageEl.classList.add('page-enter');
        }
    }
}

export default LayoutSeasonComponent;